<template>
  <div class="header-bar_op">
    <div class="header-content">
      <div class="logo-wrap" @click="$router.push({ name: 'home' })">
        <img src="@/assets/images/user/logo1.svg" class="header-logo" />
        <div class="logo-text">
          <div class="cn">月兔调查</div>
          <div class="en">YueTu&nbsp;&nbsp;Survey</div>
        </div>
      </div>
      <el-button v-if="isLogin" plain size="mini" @click="exit">退出登录</el-button>
    </div>
  </div>
</template>

<script>
import { getCookies, removeCookies } from "@/util/auth";
export default {
  data() {
    return {};
  },
  computed: {
    isLogin() {
      let token = getCookies("Access-Token");
      return !!token;
    }
  },
  methods: {
    exit() {
      removeCookies("Access-Token");
      removeCookies("Token-Type");
      
      // 重新加载整个页面
      window.location.href = "/admin";
    }
  }
};
</script>

<style lang="less" scoped>
.header-bar_op {
  height: 65px;
  border-bottom: 1px solid #e1e6f0;

  .header-content {
    width: 1200px;
    padding: 0 50px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 65px;
  }

  .logo-wrap {
    display: inline-block;
    cursor: pointer;
  }

  .header-logo {
    height: 40px;
    display: inline-block;
    vertical-align: middle;
  }

  .logo-text {
    color: #1d82fc;
    margin-left: 12px;
    line-height: 1;
    display: inline-block;
    vertical-align: middle;
  }

  .cn {
    font-size: 18px;
  }

  .en {
    font-size: 11px;
    margin-top: 6px;
  }
}
</style>